import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VirtualshowroomRoutingModule } from './virtualshowroom-routing.module';
import { ShowroomComponent } from './showroom/showroom.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
const routes = [
  { path: '', component: ShowroomComponent, data: { shouldDetach: true } }
]
@NgModule({
  declarations: [
    ShowroomComponent
  ],
  imports: [
    CommonModule,
    VirtualshowroomRoutingModule,
    SharedModule,
    RouterModule.forChild(routes),
    MaterialModule
  ]
})
export class VirtualshowroomModule { }
